import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IRegEdIntegrationStatus } from './types';
import { invalidateRegEdIntegration, setRegEdIntegration } from './useRegEdIntegrationQuery';

/**
 * The `enabled` kill-switch is what routes the account onto (or off) RegEd — configuring the
 * integration alone doesn't. 404s if the account has no integration doc yet (upsert one first).
 */
export const useRegEdIntegrationEnabledMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (result: IRegEdIntegrationStatus) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			enabled,
			impersonationContext,
		}: {
			enabled: boolean;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync<IRegEdIntegrationStatus>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					queryParams: { enabled },
					urlPath: 'compliance/regEd/integration/enabled',
				}),
				'PUT',
				null
			),
		onError,
		onSuccess: (result, { impersonationContext }) => {
			setRegEdIntegration(impersonationContext?.account?.id, result);
			invalidateRegEdIntegration();
			onSuccess?.(result);
		},
	});
};
